<template>
  <div>
    <loading v-if="load" :fullscrean="true" init="true"/>
    <div v-if="!load">
      <div class="homepage">
        <div class="container-home text-center px-3 mb-4">
          <img class="mb-4" :src="base_assets + '/logo.png'" :alt="envEmpresa.VUE_APP_TITLE" style="width: auto; height: 56px">
          <h1 class="h5 font-weight-bold mb-0">Selecione uma de nossas unidades</h1>
        </div>
        <div class="container-home">
          <div class="container">
            <div class="form-search mb-3">
              <span class="input-icon"><i class="fa fa-search"></i></span>
              <input id="logradouro" type="search" class="form-control" placeholder="Buscar unidade" v-model="query"/>
            </div>
            <hr>
            <div v-for="e in searchUnidades" :key="e.id_empresa">
              <a :href="`/unidade/${e.dominio_delivery}${redirect}`">
                <div class="lista media text-dark not-decoration align-items-center">
                  <div class="position-relative" style="margin-right: 12px; margin-bottom: 5px">
                    <img :src="e.url_imagem" aria-hidden="true" alt="empresa">
                    <div class="badge-franquia small">
                      <span class="badge badge-success" v-if="e.aberto">ABERTO</span>
                      <span class="badge badge-danger" v-else>FECHADO</span>
                    </div>
                  </div>
                  <div class="media-body my-2">
                    <h4 class="h6 m-0 text-dark limite-1">{{e.nome_fantasia}}</h4>
                    <div class="small">
                      <div class="d-flex align-items-center flex-wrap">
                        <span v-if="e.tipo_delivery !== '3'">Retirada: <b>{{ e.media_retirada }} mins</b></span>
                        <i class="i-point mx-2" v-if="e.tipo_delivery === '1'"></i>
                        <span v-if="e.tipo_delivery !== '2'">Entrega: <b>{{ e.media_entrega }} mins</b></span>
                      </div>
                      <div>
                        {{e.bairro}} - {{e.nome_cidade}} ({{e.sigla_estado}})
                      </div>
                    </div>
                    <div class="unidade-info" v-if="e.agendamento && !e.aberto"><i class="fa-solid fa-calendar-days mr-1" aria-hidden="true"></i><span><b>Agendamento</b></span></div>
                    <div class="unidade-info" v-if="e.proximo_horario"><i class="fa-solid fa-clock mr-1" aria-hidden="true"></i><span>Abre {{ e.proximo_horario.label }} às <b>{{ e.proximo_horario.horario_inicio }}</b></span></div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container-lecard">
        <ads-le-card hide-ads="true"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../../components/Loading";
  import AdsLeCard from "../../../components/AdsLeCard";

  export default {
    name: 'Franquia',
    components: {Loading, AdsLeCard},
    data() {
      return {
        load: true,
        token: localStorage.getItem('token'),
        query: '',
        franquia: [],
        redirect: ''
      }
    },

    methods: {
      getFranquia() {
        this.load = true;
        this.$http.get('v2/franquia', { params: { dominio: this.dominio } })
          .then(response => {
            const franquias = response.data || [];

            if (franquias.length) {
              this.load = false;
              this.franquia = response.data;

            } else {
              this.load = false;
              this.$router.push({ path: '/404', replace: true });
            }

          }, res => {
            this.load = false;
          });
      },
    },

    mounted() {
      this.redirect = sessionStorage.getItem('redirect') || '';
      sessionStorage.removeItem('recomendados');
      this.getFranquia();
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      unidades() {
        return this.franquia.map(u => {
          const status = u.status || {};
          const media_retirada = parseInt(u.media_retirada || '15');
          const media_entrega = parseInt(u.media_entrega || '30');

          return {
            ...u,
            media_entrega,
            media_retirada,
            aberto: status.ativo === '1' && status.aberto === '1',
            agendamento: String(u.agendamento_ativo) === '1',
            proximo_horario: status.proximo_horario || null,
            score: media_retirada + media_entrega,
            _search: this.$helpers.normalizeString(`${u.nome_fantasia} ${u.bairro} ${u.nome_cidade} ${u.sigla_estado}`)
          }
        }).sort((a, b) => {
          // Abertas primeiro
          if (a.aberto !== b.aberto) {
            return a.aberto ? -1 : 1;
          }

          // Se ambos fechados → não precisa ordenar
          if (!a.aberto && !b.aberto) {
            return 0;
          }

          // Ambos abertos → ordenar pelo score (retirada + entrega)
          return a.score - b.score;
        });
      },

      searchUnidades() {
        return this.unidades.filter(u => u._search.includes(this.query.toLowerCase()));
      }
    }
  }
</script>
<style scoped>
  .homepage {
    padding-top: 40px;
    min-height: calc(100vh - 152px);
  }

  .container-home {
    width: 100%;
    margin: 0 auto;
    max-width: 560px;
  }

  .container-lecard {
    margin: 0 0 32px;
    background-color: #F4F5F7;
  }

  .media {
    min-height: 120px;
  }

  .media img {
    width: 72px;
    height: 72px;
    object-fit: cover;
    border-radius: 50%;
    display: inline-block;
    padding: 4px;
    border: 1px solid #dee2e6;
  }

  .lista {
    cursor: pointer;
    padding: 8px 10px;
    margin-bottom: 12px;
    background-color: #ffffff;
    border-radius: 18px;
    box-shadow: var(--shadow);
  }

  .badge-franquia {
    left: 50%;
    bottom: -4px;
    transform: translateX(-50%);
    position: absolute;
  }

  .badge-franquia .badge {
    border: 1px solid #ffffff;
    border-radius: 8px;
  }

  .unidade-info {
    display: inline-flex;
    align-items: center;
    color: #595959;
    background-color: #f2f2f2;
    border-radius: 999px;
    padding: 5px 12px;
    margin-top: 4px;
    margin-right: 4px;
    font-size: 0.7rem;
    font-weight: normal;
  }

  .unidade-info i {
    line-height: 1;
    transform: translateY(-1px);
  }
</style>
